module.exports = __webpack_public_path__ + "static/media/alphabets.6116ba89.jpg";